import type { AnalyticsObject, AnalyticsProperties } from '../types'

export interface CouponScreenProperties extends AnalyticsProperties {
  providerSlug: string
  couponPromoCode: string
  couponPromoValueProposition: string
}

export class CouponScreen implements AnalyticsObject {
  name = 'Coupon Screen'
  properties: CouponScreenProperties

  constructor(params: {
    providerSlug: string
    couponPromoCode: string
    couponPromoValueProposition: string
  }) {
    this.properties = {
      providerSlug: params.providerSlug,
      couponPromoCode: params.couponPromoCode,
      couponPromoValueProposition: params.couponPromoValueProposition,
    }
  }
}
